import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    padding: 5,
    background: 'white'
  },
  logo: {
    height: 32,
    position: 'absolute',
    margin: 'auto',
    top: 12,
    left: 0,
    right: 0
  }
})
